export class NewFinStatusReasonTagCache {
  static selectFieldCacheKey() {
    return `select-field-new-fin-status-reason-tags`;
  }
}
